module.exports = __webpack_public_path__ + "img/forget-password.f70a2973.png";